const STORAGE_PREFIX = 'testsuite_active_application_environment';

const preferenceKey = (applicationId, userId = '') => {
  const normalizedApplicationId = String(applicationId || '').trim();
  const normalizedUserId = String(userId || '').trim() || 'current';
  return normalizedApplicationId
    ? `${STORAGE_PREFIX}:${normalizedUserId}:${normalizedApplicationId}`
    : '';
};

export const applicationEnvironmentPreferenceUserId = (user = {}) => String(
  user?.id || user?.user_id || user?.email || ''
).trim();

export const getActiveApplicationEnvironmentId = (applicationId, userId = '') => {
  const key = preferenceKey(applicationId, userId);
  if (!key || typeof window === 'undefined') return '';
  try {
    return String(window.localStorage.getItem(key) || '').trim();
  } catch (_error) {
    return '';
  }
};

export const setActiveApplicationEnvironmentId = (applicationId, environmentId, userId = '') => {
  const key = preferenceKey(applicationId, userId);
  if (!key || typeof window === 'undefined') return;
  try {
    const normalizedEnvironmentId = String(environmentId || '').trim();
    if (normalizedEnvironmentId) window.localStorage.setItem(key, normalizedEnvironmentId);
    else window.localStorage.removeItem(key);
  } catch (_error) {
    // A blocked storage preference must not prevent environment selection for this visit.
  }
};
